import { requireAuth } from '@/auth/requireAuth';
import { MonthSelectorWrapper } from '@/components/month-selector-wrapper'
import { columns } from '@/components/tasks/task-columns';
import { DataTable } from '@/components/tasks/task-data-table';
import { PageTitle } from '@/layout/page-title'
import { getClosingDate } from '@/utils/closing-date';
import { createFileRoute, useLoaderData } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/_layout/tasks/')({
  component: RouteComponent,
  validateSearch: () => ({}) as { month?: number; year?: number, overdue?: boolean },
  beforeLoad: requireAuth,
  loaderDeps: ({ search: { month, year, overdue } }) => {
    const closingDate = getClosingDate();
    return {
      month: month ?? closingDate.month, // Default to current month if not provided
      year: year ?? closingDate.year, // Default to current year if not provided
      overdue: overdue ?? false, // Default to false if not provided
    }
  },
  pendingComponent: () => <div className="text-center">Loading tasks...</div>,
  pendingMs: 500,
  loader: async ({ deps }) => {
    const { month, year, overdue } = deps;
    return { month, year, overdue };
  },
})

function RouteComponent() {

  const { month, year, overdue } = useLoaderData({ from: '/(app)/_layout/tasks/' });


  return (

    <div className="container max-w-[1900px] mx-auto py-10 px-4">
      <div className="space-y-4">
        <PageTitle title="Tasks" rightActions={
          <div className="max-w-[350px]">
            <MonthSelectorWrapper initialMonth={month} initialYear={year} />
          </div>
        } />
        <DataTable
          excludeNotApplicable={false}
          columns={columns}
          month={month}
          year={year}
          source='personal'
          defaultOverdue={overdue ?? false}
        />
      </div>
    </div>
  )
}
